<template>
  <div class="u-page" v-if="!hidePage">
    <Page
      class="page"
      ref="ivuPage"
      :show-elevator="showElevator"
      :show-sizer="showSizer"
      :page-size-opts="pageSizeOpts"
      :current="current"
      :total="total"
      :page-size="pageSize"
      :show-total="showTotal"
      @on-change="onChange"
    ></Page>
    <Button type="primary" class="u-page-btn" @click="changePage">确定</Button>
  </div>
</template>

<script>
import "@/styles/component/uPage.less";
import emitter from "@/mixins/emitter";
export default {
  name: "uPage",
  mixins: [emitter],
  props: {
    total: {
      //数据总数
      type: Number,
      default: 0
    },
    hideLessOne: {
      type: Boolean,
      default: false
    },
    current: {
      //当前页码，支持 .sync 修饰符
      type: Number
    },
    pageSize: {
      //每页条数
      type: Number
    },
    showElevator: {
      //显示电梯，可以快速切换到某一页
      type: Boolean
    },
    showSizer: {
      //显示分页，用来改变page-size
      type: Boolean
    },
    pageSizeOpts: {
      //每页条数切换的配置
      type: Array,
      default() {
        return [10, 20, 30, 40];
      }
    },
    placement: {
      //条数切换弹窗的展开方向，可选值为 bottom 和 top
      type: String
    },
    showTotal: {
      type: Boolean
    }
  },
  data() {
    return {
      currentPageSize: this.pageSize
    }
  },
  computed: {
    allPages() {
      const allPage = Math.ceil(this.total / this.currentPageSize);
      return (allPage === 0) ? 1 : allPage;
    },
    hidePage() {
      return this.hideLessOne && this.allPages <= 1;
    }
  },
  methods: {
    onChange(page) {
      //page 改变后的页码
      this.$emit("on-change", page);
    },
    changePage() {
      //点击确定之后，触发iview Page组件changePage事件
      let page = 1;
      let ivuPage = this.$refs.ivuPage;
      const allPages = ivuPage.allPages;
      let firstChildren = ivuPage.$children[0];
      let _currentValue = firstChildren.$el.querySelector("input[type=text]").value;
      const val = parseInt(_currentValue);
      if (val > allPages) {
        page = allPages;
      } else if (val <= 0 || !val) {
        page = 1;
      } else {
        page = val;
      }
      ivuPage.changePage(page);
    }
  },
  watch: {
    pageSize(val) {
      this.currentPageSize = val;
    }
  }
};
</script>
